<div class="m-2">
  <p-tree
    [value]="treeData"
    [selectionMode]="selectionMode"
    (onNodeSelect)="nodeSelect($event)"
    (onNodeUnselect)="nodeUnselect($event)"
  ></p-tree>
</div>
